import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Nasz wybór',
  bestPriceBadge: 'Najlepsza cena',
};
